import { Content } from 'pdfmake/interfaces';
import { TableRow } from '@angular-generic-table/core/lib/models/table-row.interface';
import { Observable } from 'rxjs';
import { TableConfig } from '@angular-generic-table/core';
import { SbKeyMetrics } from '../../../shared/components/sb-key-metrics/sb-key-metrics.component';
import { Styles } from '../print.utils';

// base interface with common properties
export interface BasePdfReportItem {
    id: string; // unique identifier
    name?: string; // name of the item, displayed on export interface
    fixed?: boolean; // whether the item should be fixed on the page, if true it's not optional or draggable
    disabled?: boolean; // whether the item is disabled (not included in the export)
    orientation?: 'portrait' | 'landscape'; // orientation of the item
    unbreakable?: boolean; // whether the item should be unbreakable (not split across pages)
    description?: string; // description of the item, displayed on export interface
    createdAt: number; // creation date
    order: number; // order of the item
    imageAssets?: Record<string, string>; // assets used in the item
    content?: Content; // content to be prepended to the item
    icon: string; // icon to be displayed on the export interface
}

// specific interfaces for each type
export interface TablePdfReportItem extends BasePdfReportItem {
    type: 'table';
    table: {
        data$: Observable<TableRow[]>;
        config$: Observable<TableConfig>;
        style?: Array<Styles>;
    };
}

export interface ImagePdfReportItem extends BasePdfReportItem {
    type: 'image';
    image: {
        querySelector: string;
    };
}

export interface KeyMetricsPdfReportItem extends BasePdfReportItem {
    type: 'keyMetrics';
    keyMetrics: {
        heading?: string;
        data$: Observable<SbKeyMetrics>;
    };
}

export interface ContentPdfReportItem extends BasePdfReportItem {
    type: 'content';
    content: Content;
}

// union type for all report items
export type PdfReportItem =
    | TablePdfReportItem
    | ImagePdfReportItem
    | KeyMetricsPdfReportItem
    | ContentPdfReportItem;

// input types for creating new items
export type PdfReportItemInput =
    | Omit<TablePdfReportItem, 'id' | 'createdAt' | 'icon'>
    | Omit<ImagePdfReportItem, 'id' | 'createdAt' | 'icon'>
    | Omit<KeyMetricsPdfReportItem, 'id' | 'createdAt' | 'icon'>
    | Omit<ContentPdfReportItem, 'id' | 'createdAt' | 'icon'>;

export function createPdfReportItem(params: Partial<PdfReportItem>): PdfReportItem {
    let icon = '';
    switch (params.type) {
        case 'table':
            icon = 'table';
            break;
        case 'image':
            // TODO: support different icons for images?
            icon = 'chart-histogram';
            break;
        case 'keyMetrics':
            icon = 'gauge';
            break;
        case 'content':
            icon = 'file';
    }
    return {
        id: params.order + '_' + new Date().getTime(),
        createdAt: new Date().getTime(),
        icon,
        ...params
    } as PdfReportItem;
}
